module.exports = __webpack_public_path__ + "img/jv.9be0fcaa.svg";